import { useIsaiahContextEngine } from "./IsaiahContextEngine";

/**
 * IsaiahContextActivator
 * Invisible component that activates the context engine.
 * Place alongside IsaiahFloatingCompanion to enable smart behavior.
 * Renders nothing, just runs the hooks.
 */
const IsaiahContextActivator = () => {
  useIsaiahContextEngine();
  return null;
};

export default IsaiahContextActivator;
